import React from 'react'

export default function VisiGiftVisitDiary() {
  return (
    <div>VisiGiftVisitDiary</div>
  )
}
